import dryEditorClass from './DryEditorClass';
import DryEditor from './DryEditor';

const baseState = {
  noteTitle: '',
  body: '',
  savedNote: false,
};

export {
  DryEditor as Editor,
  dryEditorClass,
  baseState,
};